import styled from '@emotion/styled';

const NumberBox = styled.span`
    position: absolute;
    right: -6px;
    top: -6px;
    background: red;
    z-index: 34;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    color: white;
    text-align: center;
    font-size: 12px;
    display: flex;
    font-weight: bold;
    align-items: center;
    justify-content: center;
`;

const NumberStamp = ({ width, height, children }) => <NumberBox
  style={{ width, height }}>{children}</NumberBox>;

export default NumberStamp;